<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss">
/* 清除内外边距 */
* {
  margin: 0;
  padding: 0;
}
html {
  font-size: 26.666666vw !important;
}
.myMain {
  max-width: 1200px;
  margin: 0 auto;
}
address,
cite,
dfn,
em,
var,
i {
  font-style: normal;
} /* 将斜体扶正 */
b,
strong {
  font-weight: normal;
} /* 将粗体扶细 */

/* 重置列表元素 */
ul,
ol {
  list-style: none;
}

/* 重置表格元素 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/* 重置 hr */
hr {
  border: none;
  height: 1px;
}
.clearFix::after {
  content: "";
  display: block;
  clear: both;
}
/* 清除浮动 */
.clearfix::after {
  display: block;
  height: 0;
  content: "";
  clear: both;
  visibility: hidden;
}
@media screen and (max-width: 960px) {
  .myMain {
    width: 100%;
  }
}
.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
